import React, { useRef } from 'react';
import { ResultModal } from './v2/ResultModal.styles';
import QuotationCard from '../../../reusable/QuotationCard';
import RiskCard from '../Cards/RiskCard';

// Capitalises the first letter of every word (also after "/" and "(") without
// touching the rest, so acronyms like "RC" survive. Only applied to the default
// title (type.name); a custom `title` is shown exactly as given.
export const capitalizeTitle = (str) => (typeof str === 'string'
  ? str.replace(/(^|[\s/(])([a-zà-ÿ])/g, (_, sep, ch) => sep + ch.toUpperCase())
  : str);

// Shared modal for the result pages whose modal body is identical:
//  - res_civile      -> QuotationCard (main quote)
//  - any other type  -> RiskCard, only for quotes of the selected main quote's company
//  - no main quote   -> QuotationCard
// Each product keeps its own conditions by wrapping this component and passing
// its own custom `title` when it has one (and `matchByCode`, when risk quotes must also match on code).
function ResultPageModal({
  type,
  title,
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  processingQuote,
  matchByCode = false,
}) {
  const closeButtonRef = useRef(null);

  const closeButton = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click(); // Close the modal
    }
  };

  const selectQuote = (quoteId) => {
    selectQuotation(quoteId, closeButton);
  };

  const isRiskQuoteOfProcessing = (quote) => processingQuote != null
    && processingQuote.company_id === quote.company_id
    && type.id !== 'res_civile'
    && (!matchByCode || processingQuote.code === quote.code);

  return (
    <ResultModal
      className="modal fade"
      id={type.id}
      tabIndex="-1"
      aria-labelledby={type.name}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={type.name}>
              {title ?? capitalizeTitle(type.name)}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="buttonCloseHard"
              ref={closeButtonRef}
            />
          </div>
          <div className="modal-body">
            {addingQuote && (
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Aggiungendo...</span>
                  </div>
                </div>
                <div className="ms-2">Aggiungendo...</div>
              </div>
            )}
            {addingQuote === false && quotations[type.id]
              ? quotations[type.id].map((quote, index) => (
                <React.Fragment key={index}>
                  {(type.id === 'res_civile' && processingQuote != null) && (
                    <div className="col-12 mb-2 mt-3">
                      <QuotationCard
                        requestInfo={insuranceRequest}
                        quote={quote}
                        selectQuotation={selectQuote}
                      />
                    </div>
                  )}
                  {isRiskQuoteOfProcessing(quote) ? (
                    <div className="col-12 mb-2 mt-3">
                      <RiskCard
                        type={type}
                        requestInfo={insuranceRequest}
                        quote={quote}
                        selectQuotation={selectQuote}
                      />
                    </div>
                  ) : ''}

                  {processingQuote == null && (
                    <div className="col-12 mb-2 mt-3">
                      <QuotationCard
                        requestInfo={insuranceRequest}
                        quote={quote}
                        selectQuotation={selectQuote}
                      />
                    </div>
                  )}
                </React.Fragment>
              ))
              : addingQuote === false && (
                <p>
                  {`Nessuna Quotazione ${type.name} Trovata.`}
                </p>
              )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger px-4"
              data-bs-dismiss="modal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default ResultPageModal;
